/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type AdditionalDataHolder, type ApiError, type DateOnly, type Guid, type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

export interface AccountCyclePutRequest extends AdditionalDataHolder, Parsable {
    /**
     * The cycleFrequency property
     */
    cycleFrequency: FrequencyType;
    /**
     * The cycleFrequencyMultiple property
     */
    cycleFrequencyMultiple: number;
    /**
     * The lastCycleStart property
     */
    lastCycleStart: DateOnly;
}
export interface AccountGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The cycleFrequency property
     */
    cycleFrequency: FrequencyType;
    /**
     * The cycleFrequencyMultiple property
     */
    cycleFrequencyMultiple: number | null;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The lastCycleStart property
     */
    lastCycleStart: DateOnly | null;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The name property
     */
    name: string;
    /**
     * The overdraft property
     */
    overdraft: number | null;
    /**
     * The url property
     */
    url: string | null;
}
export interface AccountPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The overdraft property
     */
    overdraft?: number | null;
    /**
     * The url property
     */
    url?: string | null;
}
export interface AccountPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The name property
     */
    name: string;
    /**
     * The overdraft property
     */
    overdraft?: number | null;
}
export interface AccountsOverviewGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balances property
     */
    balances: AccountsOverviewGetResponseBalance[];
}
export interface AccountsOverviewGetResponseBalance extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
}
export interface BalancePutRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountCyclePutRequest}
 */
// @ts-ignore
export function createAccountCyclePutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountCyclePutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountGetResponse}
 */
// @ts-ignore
export function createAccountGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountPatchRequest}
 */
// @ts-ignore
export function createAccountPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountPostRequest}
 */
// @ts-ignore
export function createAccountPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountsOverviewGetResponseBalance}
 */
// @ts-ignore
export function createAccountsOverviewGetResponseBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountsOverviewGetResponseBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountsOverviewGetResponse}
 */
// @ts-ignore
export function createAccountsOverviewGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountsOverviewGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BalancePutRequest}
 */
// @ts-ignore
export function createBalancePutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBalancePutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCreditCardRequest}
 */
// @ts-ignore
export function createCreateCreditCardRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCreditCardRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardGetResponse}
 */
// @ts-ignore
export function createCreditCardGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardHistoryGetResponse}
 */
// @ts-ignore
export function createCreditCardHistoryGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardHistoryGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardPatchRequest}
 */
// @ts-ignore
export function createCreditCardPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardPaymentPostRequest}
 */
// @ts-ignore
export function createCreditCardPaymentPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardPaymentPostRequest;
}
export interface CreateCreditCardRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The creditLimit property
     */
    creditLimit: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The minimumRepaymentPercentage property
     */
    minimumRepaymentPercentage?: number | null;
    /**
     * The minimumRepaymentPlusInterest property
     */
    minimumRepaymentPlusInterest?: boolean | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The paymentBehaviour property
     */
    paymentBehaviour?: CreditCardPaymentBehaviour | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardsOverviewBalance}
 */
// @ts-ignore
export function createCreditCardsOverviewBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardsOverviewBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCardsOverviewGetResponse}
 */
// @ts-ignore
export function createCreditCardsOverviewGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCardsOverviewGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CyclesGetResponse}
 */
// @ts-ignore
export function createCyclesGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCyclesGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DebtForecastGetAllResponse}
 */
// @ts-ignore
export function createDebtForecastGetAllResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDebtForecastGetAllResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DebtForecastGetResponse}
 */
// @ts-ignore
export function createDebtForecastGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDebtForecastGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DebtForecastGetResponseMonth}
 */
// @ts-ignore
export function createDebtForecastGetResponseMonthFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDebtForecastGetResponseMonth;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DebtForecastPatchRequest}
 */
// @ts-ignore
export function createDebtForecastPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDebtForecastPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DebtForecastPostRequest}
 */
// @ts-ignore
export function createDebtForecastPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDebtForecastPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExchangeRatesGetResponse}
 */
// @ts-ignore
export function createExchangeRatesGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExchangeRatesGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountGetAllResponse}
 */
// @ts-ignore
export function createInvestmentAccountGetAllResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountGetAllResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountGetAllResponseHoldingValue}
 */
// @ts-ignore
export function createInvestmentAccountGetAllResponseHoldingValueFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountGetAllResponseHoldingValue;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountGetResponse}
 */
// @ts-ignore
export function createInvestmentAccountGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountPatchRequest}
 */
// @ts-ignore
export function createInvestmentAccountPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountPostRequest}
 */
// @ts-ignore
export function createInvestmentAccountPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountsOverviewGetResponseBalance}
 */
// @ts-ignore
export function createInvestmentAccountsOverviewGetResponseBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountsOverviewGetResponseBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountsOverviewGetResponseCurrencyBalance}
 */
// @ts-ignore
export function createInvestmentAccountsOverviewGetResponseCurrencyBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountsOverviewGetResponseCurrencyBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountsOverviewGetResponse}
 */
// @ts-ignore
export function createInvestmentAccountsOverviewGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountsOverviewGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountTickerGetResponse}
 */
// @ts-ignore
export function createInvestmentAccountTickerGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountTickerGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountTickerPostRequest}
 */
// @ts-ignore
export function createInvestmentAccountTickerPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountTickerPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountTransactionGetResponse}
 */
// @ts-ignore
export function createInvestmentAccountTransactionGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountTransactionGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountTransactionPatchRequest}
 */
// @ts-ignore
export function createInvestmentAccountTransactionPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountTransactionPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvestmentAccountTransactionPostRequest}
 */
// @ts-ignore
export function createInvestmentAccountTransactionPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvestmentAccountTransactionPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LoanGetResponse}
 */
// @ts-ignore
export function createLoanGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLoanGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LoanPatchRequest}
 */
// @ts-ignore
export function createLoanPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLoanPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LoanPostRequest}
 */
// @ts-ignore
export function createLoanPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLoanPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LoansOverviewBalance}
 */
// @ts-ignore
export function createLoansOverviewBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLoansOverviewBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LoansOverviewGetResponse}
 */
// @ts-ignore
export function createLoansOverviewGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLoansOverviewGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MortgageGetResponse}
 */
// @ts-ignore
export function createMortgageGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMortgageGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MortgagePatchRequest}
 */
// @ts-ignore
export function createMortgagePatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMortgagePatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MortgagePostRequest}
 */
// @ts-ignore
export function createMortgagePostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMortgagePostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MortgagesOverviewBalance}
 */
// @ts-ignore
export function createMortgagesOverviewBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMortgagesOverviewBalance;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MortgagesOverviewGetResponse}
 */
// @ts-ignore
export function createMortgagesOverviewGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMortgagesOverviewGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProblemDetails}
 */
// @ts-ignore
export function createProblemDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProblemDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionalBalanceGetResponse}
 */
// @ts-ignore
export function createPromotionalBalanceGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionalBalanceGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionalBalancePatchRequest}
 */
// @ts-ignore
export function createPromotionalBalancePatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionalBalancePatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionalBalancePostRequest}
 */
// @ts-ignore
export function createPromotionalBalancePostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionalBalancePostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ScheduledTransactionGetResponse}
 */
// @ts-ignore
export function createScheduledTransactionGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoScheduledTransactionGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ScheduledTransactionPatchRequest}
 */
// @ts-ignore
export function createScheduledTransactionPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoScheduledTransactionPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ScheduledTransactionPostRequest}
 */
// @ts-ignore
export function createScheduledTransactionPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoScheduledTransactionPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SessionGetResponse}
 */
// @ts-ignore
export function createSessionGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSessionGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitGetResponse}
 */
// @ts-ignore
export function createSplitGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitPatchRequest}
 */
// @ts-ignore
export function createSplitPatchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitPatchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitPeriodCalculationGetResponse}
 */
// @ts-ignore
export function createSplitPeriodCalculationGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitPeriodCalculationGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitPeriodCalculationItem}
 */
// @ts-ignore
export function createSplitPeriodCalculationItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitPeriodCalculationItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitPostRequest}
 */
// @ts-ignore
export function createSplitPostRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitPostRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitScheduledTransactionGetRequest}
 */
// @ts-ignore
export function createSplitScheduledTransactionGetRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitScheduledTransactionGetRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitScheduledTransactionPutRequest}
 */
// @ts-ignore
export function createSplitScheduledTransactionPutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitScheduledTransactionPutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StaticCurrency}
 */
// @ts-ignore
export function createStaticCurrencyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStaticCurrency;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StatusGetResponse}
 */
// @ts-ignore
export function createStatusGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStatusGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TransactionsGetResponse}
 */
// @ts-ignore
export function createTransactionsGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTransactionsGetResponse;
}
export interface CreditCardGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The creditLimit property
     */
    creditLimit: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The interestRate property
     */
    interestRate: number | null;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The minimumRepaymentPercentage property
     */
    minimumRepaymentPercentage: number | null;
    /**
     * The minimumRepaymentPlusInterest property
     */
    minimumRepaymentPlusInterest: boolean;
    /**
     * The name property
     */
    name: string;
    /**
     * The notes property
     */
    notes: string | null;
    /**
     * The paymentBehaviour property
     */
    paymentBehaviour?: CreditCardPaymentBehaviour | null;
    /**
     * The promotionalBalance property
     */
    promotionalBalance: number;
    /**
     * The repaymentScheduledTransactionId property
     */
    repaymentScheduledTransactionId: Guid | null;
    /**
     * The url property
     */
    url: string | null;
}
export interface CreditCardHistoryGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The creditLimit property
     */
    creditLimit: number;
    /**
     * The date property
     */
    date: Date;
    /**
     * The promotionalBalance property
     */
    promotionalBalance: number;
}
export interface CreditCardPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The creditLimit property
     */
    creditLimit?: number | null;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The minimumRepaymentPercentage property
     */
    minimumRepaymentPercentage?: number | null;
    /**
     * The minimumRepaymentPlusInterest property
     */
    minimumRepaymentPlusInterest?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The paymentBehaviour property
     */
    paymentBehaviour?: CreditCardPaymentBehaviour | null;
    /**
     * The url property
     */
    url?: string | null;
}
export type CreditCardPaymentBehaviour = (typeof CreditCardPaymentBehaviourObject)[keyof typeof CreditCardPaymentBehaviourObject];
export interface CreditCardPaymentPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The accountId property
     */
    accountId?: Guid | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface CreditCardsOverviewBalance extends AdditionalDataHolder, Parsable {
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The totalAvailable property
     */
    totalAvailable?: number | null;
    /**
     * The totalBalance property
     */
    totalBalance?: number | null;
    /**
     * The totalLimit property
     */
    totalLimit?: number | null;
    /**
     * The totalNonPromotional property
     */
    totalNonPromotional?: number | null;
    /**
     * The totalPromotional property
     */
    totalPromotional?: number | null;
}
export interface CreditCardsOverviewGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balances property
     */
    balances: CreditCardsOverviewBalance[];
}
export interface CyclesGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The cycleEnd property
     */
    cycleEnd: DateOnly;
    /**
     * The cycleIndex property
     */
    cycleIndex: number;
    /**
     * The cycleStart property
     */
    cycleStart: DateOnly;
    /**
     * The difference property
     */
    difference?: number | null;
    /**
     * The totalCredit property
     */
    totalCredit: number;
    /**
     * The totalDebit property
     */
    totalDebit: number;
}
export interface DebtForecastGetAllResponse extends AdditionalDataHolder, Parsable {
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The name property
     */
    name: string;
}
export interface DebtForecastGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The creditLimit property
     */
    creditLimit: number | null;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The includeCreditCards property
     */
    includeCreditCards: boolean;
    /**
     * The includeLoans property
     */
    includeLoans: boolean;
    /**
     * The includeMortgages property
     */
    includeMortgages: boolean;
    /**
     * The income property
     */
    income: number;
    /**
     * The miscellaneousExpenses property
     */
    miscellaneousExpenses: number;
    /**
     * The months property
     */
    months: DebtForecastGetResponseMonth[];
    /**
     * The name property
     */
    name: string;
}
export interface DebtForecastGetResponseMonth extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The endOfMonthBalance property
     */
    endOfMonthBalance: number;
    /**
     * The interest property
     */
    interest: number;
    /**
     * The maximumPossiblePayment property
     */
    maximumPossiblePayment: number;
    /**
     * The month property
     */
    month: string;
    /**
     * The otherPayments property
     */
    otherPayments: number;
    /**
     * The remainder property
     */
    remainder: number;
    /**
     * The scheduledDebtPayment property
     */
    scheduledDebtPayment: number;
}
export interface DebtForecastPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The includeCreditCards property
     */
    includeCreditCards: boolean;
    /**
     * The includeLoans property
     */
    includeLoans: boolean;
    /**
     * The includeMortgages property
     */
    includeMortgages: boolean;
    /**
     * The income property
     */
    income: number;
    /**
     * The miscellaneousExpenses property
     */
    miscellaneousExpenses: number;
    /**
     * The name property
     */
    name: string;
}
export interface DebtForecastPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name: string;
}
/**
 * The deserialization information for the current model
 * @param AccountCyclePutRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountCyclePutRequest(accountCyclePutRequest: Partial<AccountCyclePutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cycleFrequency": n => { accountCyclePutRequest.cycleFrequency = n.getEnumValue<FrequencyType>(FrequencyTypeObject); },
        "cycleFrequencyMultiple": n => { accountCyclePutRequest.cycleFrequencyMultiple = n.getNumberValue(); },
        "lastCycleStart": n => { accountCyclePutRequest.lastCycleStart = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountGetResponse(accountGetResponse: Partial<AccountGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { accountGetResponse.balance = n.getNumberValue(); },
        "currencyId": n => { accountGetResponse.currencyId = n.getStringValue(); },
        "cycleFrequency": n => { accountGetResponse.cycleFrequency = n.getEnumValue<FrequencyType>(FrequencyTypeObject); },
        "cycleFrequencyMultiple": n => { accountGetResponse.cycleFrequencyMultiple = n.getNumberValue(); },
        "id": n => { accountGetResponse.id = n.getGuidValue(); },
        "lastCycleStart": n => { accountGetResponse.lastCycleStart = n.getDateOnlyValue(); },
        "lastUpdated": n => { accountGetResponse.lastUpdated = n.getDateValue(); },
        "name": n => { accountGetResponse.name = n.getStringValue(); },
        "overdraft": n => { accountGetResponse.overdraft = n.getNumberValue(); },
        "url": n => { accountGetResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountPatchRequest(accountPatchRequest: Partial<AccountPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { accountPatchRequest.balance = n.getNumberValue(); },
        "name": n => { accountPatchRequest.name = n.getStringValue(); },
        "overdraft": n => { accountPatchRequest.overdraft = n.getNumberValue(); },
        "url": n => { accountPatchRequest.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountPostRequest(accountPostRequest: Partial<AccountPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { accountPostRequest.balance = n.getNumberValue(); },
        "currencyId": n => { accountPostRequest.currencyId = n.getStringValue(); },
        "name": n => { accountPostRequest.name = n.getStringValue(); },
        "overdraft": n => { accountPostRequest.overdraft = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountsOverviewGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountsOverviewGetResponse(accountsOverviewGetResponse: Partial<AccountsOverviewGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balances": n => { accountsOverviewGetResponse.balances = n.getCollectionOfObjectValues<AccountsOverviewGetResponseBalance>(createAccountsOverviewGetResponseBalanceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountsOverviewGetResponseBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountsOverviewGetResponseBalance(accountsOverviewGetResponseBalance: Partial<AccountsOverviewGetResponseBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { accountsOverviewGetResponseBalance.balance = n.getNumberValue(); },
        "currencyId": n => { accountsOverviewGetResponseBalance.currencyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BalancePutRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBalancePutRequest(balancePutRequest: Partial<BalancePutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { balancePutRequest.balance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateCreditCardRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCreditCardRequest(createCreditCardRequest: Partial<CreateCreditCardRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { createCreditCardRequest.balance = n.getNumberValue(); },
        "creditLimit": n => { createCreditCardRequest.creditLimit = n.getNumberValue(); },
        "currencyId": n => { createCreditCardRequest.currencyId = n.getStringValue(); },
        "interestRate": n => { createCreditCardRequest.interestRate = n.getNumberValue(); },
        "minimumRepaymentPercentage": n => { createCreditCardRequest.minimumRepaymentPercentage = n.getNumberValue(); },
        "minimumRepaymentPlusInterest": n => { createCreditCardRequest.minimumRepaymentPlusInterest = n.getBooleanValue(); },
        "name": n => { createCreditCardRequest.name = n.getStringValue(); },
        "paymentBehaviour": n => { createCreditCardRequest.paymentBehaviour = n.getEnumValue<CreditCardPaymentBehaviour>(CreditCardPaymentBehaviourObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardGetResponse(creditCardGetResponse: Partial<CreditCardGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { creditCardGetResponse.balance = n.getNumberValue(); },
        "creditLimit": n => { creditCardGetResponse.creditLimit = n.getNumberValue(); },
        "currencyId": n => { creditCardGetResponse.currencyId = n.getStringValue(); },
        "id": n => { creditCardGetResponse.id = n.getGuidValue(); },
        "interestRate": n => { creditCardGetResponse.interestRate = n.getNumberValue(); },
        "lastUpdated": n => { creditCardGetResponse.lastUpdated = n.getDateValue(); },
        "minimumRepaymentPercentage": n => { creditCardGetResponse.minimumRepaymentPercentage = n.getNumberValue(); },
        "minimumRepaymentPlusInterest": n => { creditCardGetResponse.minimumRepaymentPlusInterest = n.getBooleanValue(); },
        "name": n => { creditCardGetResponse.name = n.getStringValue(); },
        "notes": n => { creditCardGetResponse.notes = n.getStringValue(); },
        "paymentBehaviour": n => { creditCardGetResponse.paymentBehaviour = n.getEnumValue<CreditCardPaymentBehaviour>(CreditCardPaymentBehaviourObject); },
        "promotionalBalance": n => { creditCardGetResponse.promotionalBalance = n.getNumberValue(); },
        "repaymentScheduledTransactionId": n => { creditCardGetResponse.repaymentScheduledTransactionId = n.getGuidValue(); },
        "url": n => { creditCardGetResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardHistoryGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardHistoryGetResponse(creditCardHistoryGetResponse: Partial<CreditCardHistoryGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { creditCardHistoryGetResponse.balance = n.getNumberValue(); },
        "creditLimit": n => { creditCardHistoryGetResponse.creditLimit = n.getNumberValue(); },
        "date": n => { creditCardHistoryGetResponse.date = n.getDateValue(); },
        "promotionalBalance": n => { creditCardHistoryGetResponse.promotionalBalance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardPatchRequest(creditCardPatchRequest: Partial<CreditCardPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { creditCardPatchRequest.balance = n.getNumberValue(); },
        "creditLimit": n => { creditCardPatchRequest.creditLimit = n.getNumberValue(); },
        "interestRate": n => { creditCardPatchRequest.interestRate = n.getNumberValue(); },
        "minimumRepaymentPercentage": n => { creditCardPatchRequest.minimumRepaymentPercentage = n.getNumberValue(); },
        "minimumRepaymentPlusInterest": n => { creditCardPatchRequest.minimumRepaymentPlusInterest = n.getBooleanValue(); },
        "name": n => { creditCardPatchRequest.name = n.getStringValue(); },
        "paymentBehaviour": n => { creditCardPatchRequest.paymentBehaviour = n.getEnumValue<CreditCardPaymentBehaviour>(CreditCardPaymentBehaviourObject); },
        "url": n => { creditCardPatchRequest.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardPaymentPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardPaymentPostRequest(creditCardPaymentPostRequest: Partial<CreditCardPaymentPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountId": n => { creditCardPaymentPostRequest.accountId = n.getGuidValue(); },
        "value": n => { creditCardPaymentPostRequest.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardsOverviewBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardsOverviewBalance(creditCardsOverviewBalance: Partial<CreditCardsOverviewBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyId": n => { creditCardsOverviewBalance.currencyId = n.getStringValue(); },
        "totalAvailable": n => { creditCardsOverviewBalance.totalAvailable = n.getNumberValue(); },
        "totalBalance": n => { creditCardsOverviewBalance.totalBalance = n.getNumberValue(); },
        "totalLimit": n => { creditCardsOverviewBalance.totalLimit = n.getNumberValue(); },
        "totalNonPromotional": n => { creditCardsOverviewBalance.totalNonPromotional = n.getNumberValue(); },
        "totalPromotional": n => { creditCardsOverviewBalance.totalPromotional = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreditCardsOverviewGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCardsOverviewGetResponse(creditCardsOverviewGetResponse: Partial<CreditCardsOverviewGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balances": n => { creditCardsOverviewGetResponse.balances = n.getCollectionOfObjectValues<CreditCardsOverviewBalance>(createCreditCardsOverviewBalanceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CyclesGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCyclesGetResponse(cyclesGetResponse: Partial<CyclesGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cycleEnd": n => { cyclesGetResponse.cycleEnd = n.getDateOnlyValue(); },
        "cycleIndex": n => { cyclesGetResponse.cycleIndex = n.getNumberValue(); },
        "cycleStart": n => { cyclesGetResponse.cycleStart = n.getDateOnlyValue(); },
        "difference": n => { cyclesGetResponse.difference = n.getNumberValue(); },
        "totalCredit": n => { cyclesGetResponse.totalCredit = n.getNumberValue(); },
        "totalDebit": n => { cyclesGetResponse.totalDebit = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DebtForecastGetAllResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDebtForecastGetAllResponse(debtForecastGetAllResponse: Partial<DebtForecastGetAllResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyId": n => { debtForecastGetAllResponse.currencyId = n.getStringValue(); },
        "id": n => { debtForecastGetAllResponse.id = n.getGuidValue(); },
        "name": n => { debtForecastGetAllResponse.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DebtForecastGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDebtForecastGetResponse(debtForecastGetResponse: Partial<DebtForecastGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "creditLimit": n => { debtForecastGetResponse.creditLimit = n.getNumberValue(); },
        "currencyId": n => { debtForecastGetResponse.currencyId = n.getStringValue(); },
        "id": n => { debtForecastGetResponse.id = n.getGuidValue(); },
        "includeCreditCards": n => { debtForecastGetResponse.includeCreditCards = n.getBooleanValue(); },
        "includeLoans": n => { debtForecastGetResponse.includeLoans = n.getBooleanValue(); },
        "includeMortgages": n => { debtForecastGetResponse.includeMortgages = n.getBooleanValue(); },
        "income": n => { debtForecastGetResponse.income = n.getNumberValue(); },
        "miscellaneousExpenses": n => { debtForecastGetResponse.miscellaneousExpenses = n.getNumberValue(); },
        "months": n => { debtForecastGetResponse.months = n.getCollectionOfObjectValues<DebtForecastGetResponseMonth>(createDebtForecastGetResponseMonthFromDiscriminatorValue); },
        "name": n => { debtForecastGetResponse.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DebtForecastGetResponseMonth The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDebtForecastGetResponseMonth(debtForecastGetResponseMonth: Partial<DebtForecastGetResponseMonth> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { debtForecastGetResponseMonth.balance = n.getNumberValue(); },
        "endOfMonthBalance": n => { debtForecastGetResponseMonth.endOfMonthBalance = n.getNumberValue(); },
        "interest": n => { debtForecastGetResponseMonth.interest = n.getNumberValue(); },
        "maximumPossiblePayment": n => { debtForecastGetResponseMonth.maximumPossiblePayment = n.getNumberValue(); },
        "month": n => { debtForecastGetResponseMonth.month = n.getStringValue(); },
        "otherPayments": n => { debtForecastGetResponseMonth.otherPayments = n.getNumberValue(); },
        "remainder": n => { debtForecastGetResponseMonth.remainder = n.getNumberValue(); },
        "scheduledDebtPayment": n => { debtForecastGetResponseMonth.scheduledDebtPayment = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DebtForecastPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDebtForecastPatchRequest(debtForecastPatchRequest: Partial<DebtForecastPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "includeCreditCards": n => { debtForecastPatchRequest.includeCreditCards = n.getBooleanValue(); },
        "includeLoans": n => { debtForecastPatchRequest.includeLoans = n.getBooleanValue(); },
        "includeMortgages": n => { debtForecastPatchRequest.includeMortgages = n.getBooleanValue(); },
        "income": n => { debtForecastPatchRequest.income = n.getNumberValue(); },
        "miscellaneousExpenses": n => { debtForecastPatchRequest.miscellaneousExpenses = n.getNumberValue(); },
        "name": n => { debtForecastPatchRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DebtForecastPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDebtForecastPostRequest(debtForecastPostRequest: Partial<DebtForecastPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { debtForecastPostRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ExchangeRatesGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExchangeRatesGetResponse(exchangeRatesGetResponse: Partial<ExchangeRatesGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyACode": n => { exchangeRatesGetResponse.currencyACode = n.getStringValue(); },
        "currencyBCode": n => { exchangeRatesGetResponse.currencyBCode = n.getStringValue(); },
        "multiplier": n => { exchangeRatesGetResponse.multiplier = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountGetAllResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountGetAllResponse(investmentAccountGetAllResponse: Partial<InvestmentAccountGetAllResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountGetAllResponse.balance = n.getNumberValue(); },
        "currencyId": n => { investmentAccountGetAllResponse.currencyId = n.getStringValue(); },
        "holdingsValues": n => { investmentAccountGetAllResponse.holdingsValues = n.getCollectionOfObjectValues<InvestmentAccountGetAllResponseHoldingValue>(createInvestmentAccountGetAllResponseHoldingValueFromDiscriminatorValue); },
        "id": n => { investmentAccountGetAllResponse.id = n.getGuidValue(); },
        "lastUpdated": n => { investmentAccountGetAllResponse.lastUpdated = n.getDateValue(); },
        "name": n => { investmentAccountGetAllResponse.name = n.getStringValue(); },
        "url": n => { investmentAccountGetAllResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountGetAllResponseHoldingValue The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountGetAllResponseHoldingValue(investmentAccountGetAllResponseHoldingValue: Partial<InvestmentAccountGetAllResponseHoldingValue> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountGetAllResponseHoldingValue.balance = n.getNumberValue(); },
        "currencyId": n => { investmentAccountGetAllResponseHoldingValue.currencyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountGetResponse(investmentAccountGetResponse: Partial<InvestmentAccountGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountGetResponse.balance = n.getNumberValue(); },
        "currencyId": n => { investmentAccountGetResponse.currencyId = n.getStringValue(); },
        "id": n => { investmentAccountGetResponse.id = n.getGuidValue(); },
        "lastUpdated": n => { investmentAccountGetResponse.lastUpdated = n.getDateValue(); },
        "name": n => { investmentAccountGetResponse.name = n.getStringValue(); },
        "url": n => { investmentAccountGetResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountPatchRequest(investmentAccountPatchRequest: Partial<InvestmentAccountPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountPatchRequest.balance = n.getNumberValue(); },
        "name": n => { investmentAccountPatchRequest.name = n.getStringValue(); },
        "url": n => { investmentAccountPatchRequest.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountPostRequest(investmentAccountPostRequest: Partial<InvestmentAccountPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountPostRequest.balance = n.getNumberValue(); },
        "currencyId": n => { investmentAccountPostRequest.currencyId = n.getStringValue(); },
        "name": n => { investmentAccountPostRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountsOverviewGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountsOverviewGetResponse(investmentAccountsOverviewGetResponse: Partial<InvestmentAccountsOverviewGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balances": n => { investmentAccountsOverviewGetResponse.balances = n.getCollectionOfObjectValues<InvestmentAccountsOverviewGetResponseBalance>(createInvestmentAccountsOverviewGetResponseBalanceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountsOverviewGetResponseBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountsOverviewGetResponseBalance(investmentAccountsOverviewGetResponseBalance: Partial<InvestmentAccountsOverviewGetResponseBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyBalances": n => { investmentAccountsOverviewGetResponseBalance.currencyBalances = n.getCollectionOfObjectValues<InvestmentAccountsOverviewGetResponseCurrencyBalance>(createInvestmentAccountsOverviewGetResponseCurrencyBalanceFromDiscriminatorValue); },
        "currencyId": n => { investmentAccountsOverviewGetResponseBalance.currencyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountsOverviewGetResponseCurrencyBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountsOverviewGetResponseCurrencyBalance(investmentAccountsOverviewGetResponseCurrencyBalance: Partial<InvestmentAccountsOverviewGetResponseCurrencyBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { investmentAccountsOverviewGetResponseCurrencyBalance.balance = n.getNumberValue(); },
        "currencyId": n => { investmentAccountsOverviewGetResponseCurrencyBalance.currencyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountTickerGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountTickerGetResponse(investmentAccountTickerGetResponse: Partial<InvestmentAccountTickerGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asAt": n => { investmentAccountTickerGetResponse.asAt = n.getDateValue(); },
        "currencyId": n => { investmentAccountTickerGetResponse.currencyId = n.getStringValue(); },
        "currentPrice": n => { investmentAccountTickerGetResponse.currentPrice = n.getNumberValue(); },
        "exchangeId": n => { investmentAccountTickerGetResponse.exchangeId = n.getStringValue(); },
        "id": n => { investmentAccountTickerGetResponse.id = n.getGuidValue(); },
        "investmentAccountId": n => { investmentAccountTickerGetResponse.investmentAccountId = n.getGuidValue(); },
        "name": n => { investmentAccountTickerGetResponse.name = n.getStringValue(); },
        "symbol": n => { investmentAccountTickerGetResponse.symbol = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountTickerPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountTickerPostRequest(investmentAccountTickerPostRequest: Partial<InvestmentAccountTickerPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exchangeId": n => { investmentAccountTickerPostRequest.exchangeId = n.getStringValue(); },
        "symbol": n => { investmentAccountTickerPostRequest.symbol = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountTransactionGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountTransactionGetResponse(investmentAccountTransactionGetResponse: Partial<InvestmentAccountTransactionGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { investmentAccountTransactionGetResponse.date = n.getDateOnlyValue(); },
        "id": n => { investmentAccountTransactionGetResponse.id = n.getGuidValue(); },
        "investmentAccountTickerId": n => { investmentAccountTransactionGetResponse.investmentAccountTickerId = n.getGuidValue(); },
        "price": n => { investmentAccountTransactionGetResponse.price = n.getNumberValue(); },
        "shares": n => { investmentAccountTransactionGetResponse.shares = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountTransactionPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountTransactionPatchRequest(investmentAccountTransactionPatchRequest: Partial<InvestmentAccountTransactionPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { investmentAccountTransactionPatchRequest.date = n.getDateOnlyValue(); },
        "price": n => { investmentAccountTransactionPatchRequest.price = n.getNumberValue(); },
        "shares": n => { investmentAccountTransactionPatchRequest.shares = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvestmentAccountTransactionPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvestmentAccountTransactionPostRequest(investmentAccountTransactionPostRequest: Partial<InvestmentAccountTransactionPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { investmentAccountTransactionPostRequest.date = n.getDateOnlyValue(); },
        "price": n => { investmentAccountTransactionPostRequest.price = n.getNumberValue(); },
        "shares": n => { investmentAccountTransactionPostRequest.shares = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LoanGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLoanGetResponse(loanGetResponse: Partial<LoanGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { loanGetResponse.balance = n.getNumberValue(); },
        "currencyId": n => { loanGetResponse.currencyId = n.getStringValue(); },
        "id": n => { loanGetResponse.id = n.getGuidValue(); },
        "interestRate": n => { loanGetResponse.interestRate = n.getNumberValue(); },
        "lastUpdated": n => { loanGetResponse.lastUpdated = n.getDateValue(); },
        "name": n => { loanGetResponse.name = n.getStringValue(); },
        "notes": n => { loanGetResponse.notes = n.getStringValue(); },
        "originalLoanAmount": n => { loanGetResponse.originalLoanAmount = n.getNumberValue(); },
        "repaymentScheduledTransactionId": n => { loanGetResponse.repaymentScheduledTransactionId = n.getGuidValue(); },
        "totalPayable": n => { loanGetResponse.totalPayable = n.getNumberValue(); },
        "url": n => { loanGetResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LoanPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLoanPatchRequest(loanPatchRequest: Partial<LoanPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { loanPatchRequest.balance = n.getNumberValue(); },
        "interestRate": n => { loanPatchRequest.interestRate = n.getNumberValue(); },
        "name": n => { loanPatchRequest.name = n.getStringValue(); },
        "notes": n => { loanPatchRequest.notes = n.getStringValue(); },
        "originalLoanAmount": n => { loanPatchRequest.originalLoanAmount = n.getNumberValue(); },
        "totalPayable": n => { loanPatchRequest.totalPayable = n.getNumberValue(); },
        "url": n => { loanPatchRequest.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LoanPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLoanPostRequest(loanPostRequest: Partial<LoanPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { loanPostRequest.balance = n.getNumberValue(); },
        "currencyId": n => { loanPostRequest.currencyId = n.getStringValue(); },
        "name": n => { loanPostRequest.name = n.getStringValue(); },
        "originalLoanAmount": n => { loanPostRequest.originalLoanAmount = n.getNumberValue(); },
        "totalPayable": n => { loanPostRequest.totalPayable = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LoansOverviewBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLoansOverviewBalance(loansOverviewBalance: Partial<LoansOverviewBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyId": n => { loansOverviewBalance.currencyId = n.getStringValue(); },
        "totalBalance": n => { loansOverviewBalance.totalBalance = n.getNumberValue(); },
        "totalOriginalLoanAmount": n => { loansOverviewBalance.totalOriginalLoanAmount = n.getNumberValue(); },
        "totalPaid": n => { loansOverviewBalance.totalPaid = n.getNumberValue(); },
        "totalPayable": n => { loansOverviewBalance.totalPayable = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LoansOverviewGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLoansOverviewGetResponse(loansOverviewGetResponse: Partial<LoansOverviewGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balances": n => { loansOverviewGetResponse.balances = n.getCollectionOfObjectValues<LoansOverviewBalance>(createLoansOverviewBalanceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param MortgageGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMortgageGetResponse(mortgageGetResponse: Partial<MortgageGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { mortgageGetResponse.balance = n.getNumberValue(); },
        "currencyId": n => { mortgageGetResponse.currencyId = n.getStringValue(); },
        "id": n => { mortgageGetResponse.id = n.getGuidValue(); },
        "interestRate": n => { mortgageGetResponse.interestRate = n.getNumberValue(); },
        "lastUpdated": n => { mortgageGetResponse.lastUpdated = n.getDateValue(); },
        "name": n => { mortgageGetResponse.name = n.getStringValue(); },
        "notes": n => { mortgageGetResponse.notes = n.getStringValue(); },
        "propertyValue": n => { mortgageGetResponse.propertyValue = n.getNumberValue(); },
        "purchaseDate": n => { mortgageGetResponse.purchaseDate = n.getDateOnlyValue(); },
        "purchasePrice": n => { mortgageGetResponse.purchasePrice = n.getNumberValue(); },
        "repaymentScheduledTransactionId": n => { mortgageGetResponse.repaymentScheduledTransactionId = n.getGuidValue(); },
        "url": n => { mortgageGetResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MortgagePatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMortgagePatchRequest(mortgagePatchRequest: Partial<MortgagePatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { mortgagePatchRequest.balance = n.getNumberValue(); },
        "interestRate": n => { mortgagePatchRequest.interestRate = n.getNumberValue(); },
        "name": n => { mortgagePatchRequest.name = n.getStringValue(); },
        "notes": n => { mortgagePatchRequest.notes = n.getStringValue(); },
        "propertyValue": n => { mortgagePatchRequest.propertyValue = n.getNumberValue(); },
        "purchaseDate": n => { mortgagePatchRequest.purchaseDate = n.getDateOnlyValue(); },
        "purchasePrice": n => { mortgagePatchRequest.purchasePrice = n.getNumberValue(); },
        "url": n => { mortgagePatchRequest.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MortgagePostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMortgagePostRequest(mortgagePostRequest: Partial<MortgagePostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { mortgagePostRequest.balance = n.getNumberValue(); },
        "currencyId": n => { mortgagePostRequest.currencyId = n.getStringValue(); },
        "name": n => { mortgagePostRequest.name = n.getStringValue(); },
        "propertyValue": n => { mortgagePostRequest.propertyValue = n.getNumberValue(); },
        "purchaseDate": n => { mortgagePostRequest.purchaseDate = n.getDateOnlyValue(); },
        "purchasePrice": n => { mortgagePostRequest.purchasePrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MortgagesOverviewBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMortgagesOverviewBalance(mortgagesOverviewBalance: Partial<MortgagesOverviewBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyId": n => { mortgagesOverviewBalance.currencyId = n.getStringValue(); },
        "totalBalance": n => { mortgagesOverviewBalance.totalBalance = n.getNumberValue(); },
        "totalEquity": n => { mortgagesOverviewBalance.totalEquity = n.getNumberValue(); },
        "totalPropertyValue": n => { mortgagesOverviewBalance.totalPropertyValue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MortgagesOverviewGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMortgagesOverviewGetResponse(mortgagesOverviewGetResponse: Partial<MortgagesOverviewGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balances": n => { mortgagesOverviewGetResponse.balances = n.getCollectionOfObjectValues<MortgagesOverviewBalance>(createMortgagesOverviewBalanceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProblemDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProblemDetails(problemDetails: Partial<ProblemDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detail": n => { problemDetails.detail = n.getStringValue(); },
        "instance": n => { problemDetails.instance = n.getStringValue(); },
        "status": n => { problemDetails.status = n.getNumberValue(); },
        "title": n => { problemDetails.title = n.getStringValue(); },
        "type": n => { problemDetails.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PromotionalBalanceGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionalBalanceGetResponse(promotionalBalanceGetResponse: Partial<PromotionalBalanceGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { promotionalBalanceGetResponse.balance = n.getNumberValue(); },
        "creditCardId": n => { promotionalBalanceGetResponse.creditCardId = n.getGuidValue(); },
        "expiry": n => { promotionalBalanceGetResponse.expiry = n.getDateOnlyValue(); },
        "id": n => { promotionalBalanceGetResponse.id = n.getGuidValue(); },
        "interestRate": n => { promotionalBalanceGetResponse.interestRate = n.getNumberValue(); },
        "lastUpdated": n => { promotionalBalanceGetResponse.lastUpdated = n.getDateValue(); },
        "started": n => { promotionalBalanceGetResponse.started = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PromotionalBalancePatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionalBalancePatchRequest(promotionalBalancePatchRequest: Partial<PromotionalBalancePatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { promotionalBalancePatchRequest.balance = n.getNumberValue(); },
        "expiry": n => { promotionalBalancePatchRequest.expiry = n.getDateOnlyValue(); },
        "interestRate": n => { promotionalBalancePatchRequest.interestRate = n.getNumberValue(); },
        "started": n => { promotionalBalancePatchRequest.started = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PromotionalBalancePostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionalBalancePostRequest(promotionalBalancePostRequest: Partial<PromotionalBalancePostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { promotionalBalancePostRequest.balance = n.getNumberValue(); },
        "expiry": n => { promotionalBalancePostRequest.expiry = n.getDateOnlyValue(); },
        "interestRate": n => { promotionalBalancePostRequest.interestRate = n.getNumberValue(); },
        "started": n => { promotionalBalancePostRequest.started = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ScheduledTransactionGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoScheduledTransactionGetResponse(scheduledTransactionGetResponse: Partial<ScheduledTransactionGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountId": n => { scheduledTransactionGetResponse.accountId = n.getGuidValue(); },
        "accountName": n => { scheduledTransactionGetResponse.accountName = n.getStringValue(); },
        "frequency": n => { scheduledTransactionGetResponse.frequency = n.getEnumValue<FrequencyType>(FrequencyTypeObject); },
        "frequencyMultiple": n => { scheduledTransactionGetResponse.frequencyMultiple = n.getNumberValue(); },
        "id": n => { scheduledTransactionGetResponse.id = n.getGuidValue(); },
        "isCredit": n => { scheduledTransactionGetResponse.isCredit = n.getBooleanValue(); },
        "isVariable": n => { scheduledTransactionGetResponse.isVariable = n.getBooleanValue(); },
        "lastPaid": n => { scheduledTransactionGetResponse.lastPaid = n.getDateOnlyValue(); },
        "nextDue": n => { scheduledTransactionGetResponse.nextDue = n.getDateOnlyValue(); },
        "payee": n => { scheduledTransactionGetResponse.payee = n.getStringValue(); },
        "value": n => { scheduledTransactionGetResponse.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ScheduledTransactionPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoScheduledTransactionPatchRequest(scheduledTransactionPatchRequest: Partial<ScheduledTransactionPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "frequency": n => { scheduledTransactionPatchRequest.frequency = n.getEnumValue<FrequencyType>(FrequencyTypeObject); },
        "frequencyMultiple": n => { scheduledTransactionPatchRequest.frequencyMultiple = n.getNumberValue(); },
        "isVariable": n => { scheduledTransactionPatchRequest.isVariable = n.getBooleanValue(); },
        "nextDue": n => { scheduledTransactionPatchRequest.nextDue = n.getDateOnlyValue(); },
        "payee": n => { scheduledTransactionPatchRequest.payee = n.getStringValue(); },
        "value": n => { scheduledTransactionPatchRequest.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ScheduledTransactionPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoScheduledTransactionPostRequest(scheduledTransactionPostRequest: Partial<ScheduledTransactionPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountId": n => { scheduledTransactionPostRequest.accountId = n.getGuidValue(); },
        "creditCardId": n => { scheduledTransactionPostRequest.creditCardId = n.getGuidValue(); },
        "frequency": n => { scheduledTransactionPostRequest.frequency = n.getEnumValue<FrequencyType>(FrequencyTypeObject); },
        "frequencyMultiple": n => { scheduledTransactionPostRequest.frequencyMultiple = n.getNumberValue(); },
        "isCredit": n => { scheduledTransactionPostRequest.isCredit = n.getBooleanValue(); },
        "isVariable": n => { scheduledTransactionPostRequest.isVariable = n.getBooleanValue(); },
        "loanId": n => { scheduledTransactionPostRequest.loanId = n.getGuidValue(); },
        "mortgageId": n => { scheduledTransactionPostRequest.mortgageId = n.getGuidValue(); },
        "nextDue": n => { scheduledTransactionPostRequest.nextDue = n.getDateOnlyValue(); },
        "payee": n => { scheduledTransactionPostRequest.payee = n.getStringValue(); },
        "value": n => { scheduledTransactionPostRequest.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SessionGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSessionGetResponse(sessionGetResponse: Partial<SessionGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "defaultCurrencyId": n => { sessionGetResponse.defaultCurrencyId = n.getStringValue(); },
        "email": n => { sessionGetResponse.email = n.getStringValue(); },
        "emailHash": n => { sessionGetResponse.emailHash = n.getStringValue(); },
        "familyName": n => { sessionGetResponse.familyName = n.getStringValue(); },
        "givenName": n => { sessionGetResponse.givenName = n.getStringValue(); },
        "id": n => { sessionGetResponse.id = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitGetResponse(splitGetResponse: Partial<SplitGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountId": n => { splitGetResponse.accountId = n.getGuidValue(); },
        "name": n => { splitGetResponse.name = n.getStringValue(); },
        "splitId": n => { splitGetResponse.splitId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitPatchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitPatchRequest(splitPatchRequest: Partial<SplitPatchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { splitPatchRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitPeriodCalculationGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitPeriodCalculationGetResponse(splitPeriodCalculationGetResponse: Partial<SplitPeriodCalculationGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "items": n => { splitPeriodCalculationGetResponse.items = n.getCollectionOfObjectValues<SplitPeriodCalculationItem>(createSplitPeriodCalculationItemFromDiscriminatorValue); },
        "total": n => { splitPeriodCalculationGetResponse.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitPeriodCalculationItem The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitPeriodCalculationItem(splitPeriodCalculationItem: Partial<SplitPeriodCalculationItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { splitPeriodCalculationItem.amount = n.getNumberValue(); },
        "scheduledTransactionId": n => { splitPeriodCalculationItem.scheduledTransactionId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitPostRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitPostRequest(splitPostRequest: Partial<SplitPostRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { splitPostRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitScheduledTransactionGetRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitScheduledTransactionGetRequest(splitScheduledTransactionGetRequest: Partial<SplitScheduledTransactionGetRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "denominator": n => { splitScheduledTransactionGetRequest.denominator = n.getNumberValue(); },
        "numerator": n => { splitScheduledTransactionGetRequest.numerator = n.getNumberValue(); },
        "scheduledTransactionId": n => { splitScheduledTransactionGetRequest.scheduledTransactionId = n.getGuidValue(); },
        "splitId": n => { splitScheduledTransactionGetRequest.splitId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SplitScheduledTransactionPutRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitScheduledTransactionPutRequest(splitScheduledTransactionPutRequest: Partial<SplitScheduledTransactionPutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "denominator": n => { splitScheduledTransactionPutRequest.denominator = n.getNumberValue(); },
        "numerator": n => { splitScheduledTransactionPutRequest.numerator = n.getNumberValue(); },
        "scheduledTransactionId": n => { splitScheduledTransactionPutRequest.scheduledTransactionId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StaticCurrency The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStaticCurrency(staticCurrency: Partial<StaticCurrency> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternateCode": n => { staticCurrency.alternateCode = n.getStringValue(); },
        "alternateMultiplier": n => { staticCurrency.alternateMultiplier = n.getNumberValue(); },
        "code": n => { staticCurrency.code = n.getStringValue(); },
        "decimalPlaces": n => { staticCurrency.decimalPlaces = n.getNumberValue(); },
        "friendlyName": n => { staticCurrency.friendlyName = n.getStringValue(); },
        "symbol": n => { staticCurrency.symbol = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StatusGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStatusGetResponse(statusGetResponse: Partial<StatusGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currency": n => { statusGetResponse.currency = n.getObjectValue<StaticCurrency>(createStaticCurrencyFromDiscriminatorValue); },
        "hasAccounts": n => { statusGetResponse.hasAccounts = n.getBooleanValue(); },
        "hasCreditCards": n => { statusGetResponse.hasCreditCards = n.getBooleanValue(); },
        "hasInvestmentAccounts": n => { statusGetResponse.hasInvestmentAccounts = n.getBooleanValue(); },
        "hasLoans": n => { statusGetResponse.hasLoans = n.getBooleanValue(); },
        "hasMortgages": n => { statusGetResponse.hasMortgages = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TransactionsGetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTransactionsGetResponse(transactionsGetResponse: Partial<TransactionsGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountId": n => { transactionsGetResponse.accountId = n.getGuidValue(); },
        "date": n => { transactionsGetResponse.date = n.getDateOnlyValue(); },
        "isCredit": n => { transactionsGetResponse.isCredit = n.getBooleanValue(); },
        "isPaid": n => { transactionsGetResponse.isPaid = n.getBooleanValue(); },
        "isVariable": n => { transactionsGetResponse.isVariable = n.getBooleanValue(); },
        "name": n => { transactionsGetResponse.name = n.getStringValue(); },
        "scheduledTransactionId": n => { transactionsGetResponse.scheduledTransactionId = n.getGuidValue(); },
        "value": n => { transactionsGetResponse.value = n.getNumberValue(); },
    }
}
export interface ExchangeRatesGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The currencyACode property
     */
    currencyACode: string;
    /**
     * The currencyBCode property
     */
    currencyBCode: string;
    /**
     * The multiplier property
     */
    multiplier: number;
}
export type FrequencyType = (typeof FrequencyTypeObject)[keyof typeof FrequencyTypeObject];
export interface InvestmentAccountGetAllResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The holdingsValues property
     */
    holdingsValues: InvestmentAccountGetAllResponseHoldingValue[];
    /**
     * The id property
     */
    id: Guid;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The name property
     */
    name: string;
    /**
     * The url property
     */
    url: string | null;
}
export interface InvestmentAccountGetAllResponseHoldingValue extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
}
export interface InvestmentAccountGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The name property
     */
    name: string;
    /**
     * The url property
     */
    url: string | null;
}
export interface InvestmentAccountPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The url property
     */
    url?: string | null;
}
export interface InvestmentAccountPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The name property
     */
    name: string;
}
export interface InvestmentAccountsOverviewGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balances property
     */
    balances: InvestmentAccountsOverviewGetResponseBalance[];
}
export interface InvestmentAccountsOverviewGetResponseBalance extends AdditionalDataHolder, Parsable {
    /**
     * The currencyBalances property
     */
    currencyBalances: InvestmentAccountsOverviewGetResponseCurrencyBalance[];
    /**
     * The currencyId property
     */
    currencyId: string;
}
export interface InvestmentAccountsOverviewGetResponseCurrencyBalance extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
}
export interface InvestmentAccountTickerGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The asAt property
     */
    asAt: Date | null;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The currentPrice property
     */
    currentPrice: number | null;
    /**
     * The exchangeId property
     */
    exchangeId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The investmentAccountId property
     */
    investmentAccountId: Guid;
    /**
     * The name property
     */
    name: string;
    /**
     * The symbol property
     */
    symbol: string;
}
export interface InvestmentAccountTickerPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The exchangeId property
     */
    exchangeId: string;
    /**
     * The symbol property
     */
    symbol: string;
}
export interface InvestmentAccountTransactionGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date: DateOnly;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The investmentAccountTickerId property
     */
    investmentAccountTickerId: Guid;
    /**
     * The price property
     */
    price: number;
    /**
     * The shares property
     */
    shares: number;
}
export interface InvestmentAccountTransactionPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date: DateOnly;
    /**
     * The price property
     */
    price: number;
    /**
     * The shares property
     */
    shares: number;
}
export interface InvestmentAccountTransactionPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date: DateOnly;
    /**
     * The price property
     */
    price: number;
    /**
     * The shares property
     */
    shares: number;
}
export interface LoanGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The interestRate property
     */
    interestRate: number | null;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The name property
     */
    name: string;
    /**
     * The notes property
     */
    notes: string | null;
    /**
     * The originalLoanAmount property
     */
    originalLoanAmount: number;
    /**
     * The repaymentScheduledTransactionId property
     */
    repaymentScheduledTransactionId: Guid | null;
    /**
     * The totalPayable property
     */
    totalPayable: number;
    /**
     * The url property
     */
    url: string | null;
}
export interface LoanPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The originalLoanAmount property
     */
    originalLoanAmount: number;
    /**
     * The totalPayable property
     */
    totalPayable: number;
    /**
     * The url property
     */
    url?: string | null;
}
export interface LoanPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The name property
     */
    name: string;
    /**
     * The originalLoanAmount property
     */
    originalLoanAmount: number;
    /**
     * The totalPayable property
     */
    totalPayable: number;
}
export interface LoansOverviewBalance extends AdditionalDataHolder, Parsable {
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The totalBalance property
     */
    totalBalance?: number | null;
    /**
     * The totalOriginalLoanAmount property
     */
    totalOriginalLoanAmount?: number | null;
    /**
     * The totalPaid property
     */
    totalPaid?: number | null;
    /**
     * The totalPayable property
     */
    totalPayable?: number | null;
}
export interface LoansOverviewGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balances property
     */
    balances: LoansOverviewBalance[];
}
export interface MortgageGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The interestRate property
     */
    interestRate: number | null;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The name property
     */
    name: string;
    /**
     * The notes property
     */
    notes: string | null;
    /**
     * The propertyValue property
     */
    propertyValue: number | null;
    /**
     * The purchaseDate property
     */
    purchaseDate: DateOnly | null;
    /**
     * The purchasePrice property
     */
    purchasePrice: number | null;
    /**
     * The repaymentScheduledTransactionId property
     */
    repaymentScheduledTransactionId: Guid | null;
    /**
     * The url property
     */
    url: string | null;
}
export interface MortgagePatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The propertyValue property
     */
    propertyValue?: number | null;
    /**
     * The purchaseDate property
     */
    purchaseDate?: DateOnly | null;
    /**
     * The purchasePrice property
     */
    purchasePrice?: number | null;
    /**
     * The url property
     */
    url?: string | null;
}
export interface MortgagePostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The name property
     */
    name: string;
    /**
     * The propertyValue property
     */
    propertyValue?: number | null;
    /**
     * The purchaseDate property
     */
    purchaseDate?: DateOnly | null;
    /**
     * The purchasePrice property
     */
    purchasePrice?: number | null;
}
export interface MortgagesOverviewBalance extends AdditionalDataHolder, Parsable {
    /**
     * The currencyId property
     */
    currencyId: string;
    /**
     * The totalBalance property
     */
    totalBalance?: number | null;
    /**
     * The totalEquity property
     */
    totalEquity?: number | null;
    /**
     * The totalPropertyValue property
     */
    totalPropertyValue?: number | null;
}
export interface MortgagesOverviewGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balances property
     */
    balances: MortgagesOverviewBalance[];
}
export interface ProblemDetails extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The detail property
     */
    detail?: string | null;
    /**
     * The instance property
     */
    instance?: string | null;
    /**
     * The status property
     */
    status?: number | null;
    /**
     * The title property
     */
    title?: string | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface PromotionalBalanceGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance: number;
    /**
     * The creditCardId property
     */
    creditCardId: Guid;
    /**
     * The expiry property
     */
    expiry: DateOnly | null;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The interestRate property
     */
    interestRate: number;
    /**
     * The lastUpdated property
     */
    lastUpdated: Date;
    /**
     * The started property
     */
    started: DateOnly | null;
}
export interface PromotionalBalancePatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The expiry property
     */
    expiry?: DateOnly | null;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The started property
     */
    started?: DateOnly | null;
}
export interface PromotionalBalancePostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The expiry property
     */
    expiry?: DateOnly | null;
    /**
     * The interestRate property
     */
    interestRate?: number | null;
    /**
     * The started property
     */
    started?: DateOnly | null;
}
export interface ScheduledTransactionGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The accountId property
     */
    accountId: Guid;
    /**
     * The accountName property
     */
    accountName: string;
    /**
     * The frequency property
     */
    frequency: FrequencyType;
    /**
     * The frequencyMultiple property
     */
    frequencyMultiple: number | null;
    /**
     * The id property
     */
    id: Guid;
    /**
     * The isCredit property
     */
    isCredit: boolean;
    /**
     * The isVariable property
     */
    isVariable: boolean;
    /**
     * The lastPaid property
     */
    lastPaid: DateOnly | null;
    /**
     * The nextDue property
     */
    nextDue: DateOnly | null;
    /**
     * The payee property
     */
    payee: string;
    /**
     * The value property
     */
    value: number;
}
export interface ScheduledTransactionPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The frequency property
     */
    frequency?: FrequencyType | null;
    /**
     * The frequencyMultiple property
     */
    frequencyMultiple?: number | null;
    /**
     * The isVariable property
     */
    isVariable?: boolean | null;
    /**
     * The nextDue property
     */
    nextDue?: DateOnly | null;
    /**
     * The payee property
     */
    payee: string;
    /**
     * The value property
     */
    value?: number | null;
}
export interface ScheduledTransactionPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The accountId property
     */
    accountId?: Guid | null;
    /**
     * The creditCardId property
     */
    creditCardId?: Guid | null;
    /**
     * The frequency property
     */
    frequency?: FrequencyType | null;
    /**
     * The frequencyMultiple property
     */
    frequencyMultiple?: number | null;
    /**
     * The isCredit property
     */
    isCredit?: boolean | null;
    /**
     * The isVariable property
     */
    isVariable?: boolean | null;
    /**
     * The loanId property
     */
    loanId?: Guid | null;
    /**
     * The mortgageId property
     */
    mortgageId?: Guid | null;
    /**
     * The nextDue property
     */
    nextDue?: DateOnly | null;
    /**
     * The payee property
     */
    payee: string;
    /**
     * The value property
     */
    value?: number | null;
}
/**
 * Serializes information the current object
 * @param AccountCyclePutRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountCyclePutRequest(writer: SerializationWriter, accountCyclePutRequest: Partial<AccountCyclePutRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountCyclePutRequest || isSerializingDerivedType) { return; }
    writer.writeEnumValue<FrequencyType>("cycleFrequency", accountCyclePutRequest.cycleFrequency);
    writer.writeNumberValue("cycleFrequencyMultiple", accountCyclePutRequest.cycleFrequencyMultiple);
    writer.writeDateOnlyValue("lastCycleStart", accountCyclePutRequest.lastCycleStart);
    writer.writeAdditionalData(accountCyclePutRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountGetResponse(writer: SerializationWriter, accountGetResponse: Partial<AccountGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", accountGetResponse.balance);
    writer.writeStringValue("currencyId", accountGetResponse.currencyId);
    writer.writeEnumValue<FrequencyType>("cycleFrequency", accountGetResponse.cycleFrequency);
    writer.writeNumberValue("cycleFrequencyMultiple", accountGetResponse.cycleFrequencyMultiple);
    writer.writeGuidValue("id", accountGetResponse.id);
    writer.writeDateOnlyValue("lastCycleStart", accountGetResponse.lastCycleStart);
    writer.writeDateValue("lastUpdated", accountGetResponse.lastUpdated);
    writer.writeStringValue("name", accountGetResponse.name);
    writer.writeNumberValue("overdraft", accountGetResponse.overdraft);
    writer.writeStringValue("url", accountGetResponse.url);
    writer.writeAdditionalData(accountGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountPatchRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountPatchRequest(writer: SerializationWriter, accountPatchRequest: Partial<AccountPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountPatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", accountPatchRequest.balance);
    writer.writeStringValue("name", accountPatchRequest.name);
    writer.writeNumberValue("overdraft", accountPatchRequest.overdraft);
    writer.writeStringValue("url", accountPatchRequest.url);
    writer.writeAdditionalData(accountPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountPostRequest(writer: SerializationWriter, accountPostRequest: Partial<AccountPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountPostRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", accountPostRequest.balance);
    writer.writeStringValue("currencyId", accountPostRequest.currencyId);
    writer.writeStringValue("name", accountPostRequest.name);
    writer.writeNumberValue("overdraft", accountPostRequest.overdraft);
    writer.writeAdditionalData(accountPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountsOverviewGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountsOverviewGetResponse(writer: SerializationWriter, accountsOverviewGetResponse: Partial<AccountsOverviewGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountsOverviewGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AccountsOverviewGetResponseBalance>("balances", accountsOverviewGetResponse.balances, serializeAccountsOverviewGetResponseBalance);
    writer.writeAdditionalData(accountsOverviewGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountsOverviewGetResponseBalance The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountsOverviewGetResponseBalance(writer: SerializationWriter, accountsOverviewGetResponseBalance: Partial<AccountsOverviewGetResponseBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountsOverviewGetResponseBalance || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", accountsOverviewGetResponseBalance.balance);
    writer.writeStringValue("currencyId", accountsOverviewGetResponseBalance.currencyId);
    writer.writeAdditionalData(accountsOverviewGetResponseBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param BalancePutRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBalancePutRequest(writer: SerializationWriter, balancePutRequest: Partial<BalancePutRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!balancePutRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", balancePutRequest.balance);
    writer.writeAdditionalData(balancePutRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateCreditCardRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCreditCardRequest(writer: SerializationWriter, createCreditCardRequest: Partial<CreateCreditCardRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createCreditCardRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", createCreditCardRequest.balance);
    writer.writeNumberValue("creditLimit", createCreditCardRequest.creditLimit);
    writer.writeStringValue("currencyId", createCreditCardRequest.currencyId);
    writer.writeNumberValue("interestRate", createCreditCardRequest.interestRate);
    writer.writeNumberValue("minimumRepaymentPercentage", createCreditCardRequest.minimumRepaymentPercentage);
    writer.writeBooleanValue("minimumRepaymentPlusInterest", createCreditCardRequest.minimumRepaymentPlusInterest);
    writer.writeStringValue("name", createCreditCardRequest.name);
    writer.writeEnumValue<CreditCardPaymentBehaviour>("paymentBehaviour", createCreditCardRequest.paymentBehaviour);
    writer.writeAdditionalData(createCreditCardRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardGetResponse(writer: SerializationWriter, creditCardGetResponse: Partial<CreditCardGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", creditCardGetResponse.balance);
    writer.writeNumberValue("creditLimit", creditCardGetResponse.creditLimit);
    writer.writeStringValue("currencyId", creditCardGetResponse.currencyId);
    writer.writeGuidValue("id", creditCardGetResponse.id);
    writer.writeNumberValue("interestRate", creditCardGetResponse.interestRate);
    writer.writeDateValue("lastUpdated", creditCardGetResponse.lastUpdated);
    writer.writeNumberValue("minimumRepaymentPercentage", creditCardGetResponse.minimumRepaymentPercentage);
    writer.writeBooleanValue("minimumRepaymentPlusInterest", creditCardGetResponse.minimumRepaymentPlusInterest);
    writer.writeStringValue("name", creditCardGetResponse.name);
    writer.writeStringValue("notes", creditCardGetResponse.notes);
    writer.writeEnumValue<CreditCardPaymentBehaviour>("paymentBehaviour", creditCardGetResponse.paymentBehaviour);
    writer.writeNumberValue("promotionalBalance", creditCardGetResponse.promotionalBalance);
    writer.writeGuidValue("repaymentScheduledTransactionId", creditCardGetResponse.repaymentScheduledTransactionId);
    writer.writeStringValue("url", creditCardGetResponse.url);
    writer.writeAdditionalData(creditCardGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardHistoryGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardHistoryGetResponse(writer: SerializationWriter, creditCardHistoryGetResponse: Partial<CreditCardHistoryGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardHistoryGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", creditCardHistoryGetResponse.balance);
    writer.writeNumberValue("creditLimit", creditCardHistoryGetResponse.creditLimit);
    writer.writeDateValue("date", creditCardHistoryGetResponse.date);
    writer.writeNumberValue("promotionalBalance", creditCardHistoryGetResponse.promotionalBalance);
    writer.writeAdditionalData(creditCardHistoryGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardPatchRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardPatchRequest(writer: SerializationWriter, creditCardPatchRequest: Partial<CreditCardPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardPatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", creditCardPatchRequest.balance);
    writer.writeNumberValue("creditLimit", creditCardPatchRequest.creditLimit);
    writer.writeNumberValue("interestRate", creditCardPatchRequest.interestRate);
    writer.writeNumberValue("minimumRepaymentPercentage", creditCardPatchRequest.minimumRepaymentPercentage);
    writer.writeBooleanValue("minimumRepaymentPlusInterest", creditCardPatchRequest.minimumRepaymentPlusInterest);
    writer.writeStringValue("name", creditCardPatchRequest.name);
    writer.writeEnumValue<CreditCardPaymentBehaviour>("paymentBehaviour", creditCardPatchRequest.paymentBehaviour);
    writer.writeStringValue("url", creditCardPatchRequest.url);
    writer.writeAdditionalData(creditCardPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardPaymentPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardPaymentPostRequest(writer: SerializationWriter, creditCardPaymentPostRequest: Partial<CreditCardPaymentPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardPaymentPostRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("accountId", creditCardPaymentPostRequest.accountId);
    writer.writeNumberValue("value", creditCardPaymentPostRequest.value);
    writer.writeAdditionalData(creditCardPaymentPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardsOverviewBalance The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardsOverviewBalance(writer: SerializationWriter, creditCardsOverviewBalance: Partial<CreditCardsOverviewBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardsOverviewBalance || isSerializingDerivedType) { return; }
    writer.writeStringValue("currencyId", creditCardsOverviewBalance.currencyId);
    writer.writeNumberValue("totalAvailable", creditCardsOverviewBalance.totalAvailable);
    writer.writeNumberValue("totalBalance", creditCardsOverviewBalance.totalBalance);
    writer.writeNumberValue("totalLimit", creditCardsOverviewBalance.totalLimit);
    writer.writeNumberValue("totalNonPromotional", creditCardsOverviewBalance.totalNonPromotional);
    writer.writeNumberValue("totalPromotional", creditCardsOverviewBalance.totalPromotional);
    writer.writeAdditionalData(creditCardsOverviewBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param CreditCardsOverviewGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCardsOverviewGetResponse(writer: SerializationWriter, creditCardsOverviewGetResponse: Partial<CreditCardsOverviewGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!creditCardsOverviewGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<CreditCardsOverviewBalance>("balances", creditCardsOverviewGetResponse.balances, serializeCreditCardsOverviewBalance);
    writer.writeAdditionalData(creditCardsOverviewGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CyclesGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCyclesGetResponse(writer: SerializationWriter, cyclesGetResponse: Partial<CyclesGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cyclesGetResponse || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("cycleEnd", cyclesGetResponse.cycleEnd);
    writer.writeNumberValue("cycleIndex", cyclesGetResponse.cycleIndex);
    writer.writeDateOnlyValue("cycleStart", cyclesGetResponse.cycleStart);
    writer.writeNumberValue("difference", cyclesGetResponse.difference);
    writer.writeNumberValue("totalCredit", cyclesGetResponse.totalCredit);
    writer.writeNumberValue("totalDebit", cyclesGetResponse.totalDebit);
    writer.writeAdditionalData(cyclesGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DebtForecastGetAllResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDebtForecastGetAllResponse(writer: SerializationWriter, debtForecastGetAllResponse: Partial<DebtForecastGetAllResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!debtForecastGetAllResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("currencyId", debtForecastGetAllResponse.currencyId);
    writer.writeGuidValue("id", debtForecastGetAllResponse.id);
    writer.writeStringValue("name", debtForecastGetAllResponse.name);
    writer.writeAdditionalData(debtForecastGetAllResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DebtForecastGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDebtForecastGetResponse(writer: SerializationWriter, debtForecastGetResponse: Partial<DebtForecastGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!debtForecastGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("creditLimit", debtForecastGetResponse.creditLimit);
    writer.writeStringValue("currencyId", debtForecastGetResponse.currencyId);
    writer.writeGuidValue("id", debtForecastGetResponse.id);
    writer.writeBooleanValue("includeCreditCards", debtForecastGetResponse.includeCreditCards);
    writer.writeBooleanValue("includeLoans", debtForecastGetResponse.includeLoans);
    writer.writeBooleanValue("includeMortgages", debtForecastGetResponse.includeMortgages);
    writer.writeNumberValue("income", debtForecastGetResponse.income);
    writer.writeNumberValue("miscellaneousExpenses", debtForecastGetResponse.miscellaneousExpenses);
    writer.writeCollectionOfObjectValues<DebtForecastGetResponseMonth>("months", debtForecastGetResponse.months, serializeDebtForecastGetResponseMonth);
    writer.writeStringValue("name", debtForecastGetResponse.name);
    writer.writeAdditionalData(debtForecastGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DebtForecastGetResponseMonth The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDebtForecastGetResponseMonth(writer: SerializationWriter, debtForecastGetResponseMonth: Partial<DebtForecastGetResponseMonth> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!debtForecastGetResponseMonth || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", debtForecastGetResponseMonth.balance);
    writer.writeNumberValue("endOfMonthBalance", debtForecastGetResponseMonth.endOfMonthBalance);
    writer.writeNumberValue("interest", debtForecastGetResponseMonth.interest);
    writer.writeNumberValue("maximumPossiblePayment", debtForecastGetResponseMonth.maximumPossiblePayment);
    writer.writeStringValue("month", debtForecastGetResponseMonth.month);
    writer.writeNumberValue("otherPayments", debtForecastGetResponseMonth.otherPayments);
    writer.writeNumberValue("remainder", debtForecastGetResponseMonth.remainder);
    writer.writeNumberValue("scheduledDebtPayment", debtForecastGetResponseMonth.scheduledDebtPayment);
    writer.writeAdditionalData(debtForecastGetResponseMonth.additionalData);
}
/**
 * Serializes information the current object
 * @param DebtForecastPatchRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDebtForecastPatchRequest(writer: SerializationWriter, debtForecastPatchRequest: Partial<DebtForecastPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!debtForecastPatchRequest || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("includeCreditCards", debtForecastPatchRequest.includeCreditCards);
    writer.writeBooleanValue("includeLoans", debtForecastPatchRequest.includeLoans);
    writer.writeBooleanValue("includeMortgages", debtForecastPatchRequest.includeMortgages);
    writer.writeNumberValue("income", debtForecastPatchRequest.income);
    writer.writeNumberValue("miscellaneousExpenses", debtForecastPatchRequest.miscellaneousExpenses);
    writer.writeStringValue("name", debtForecastPatchRequest.name);
    writer.writeAdditionalData(debtForecastPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DebtForecastPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDebtForecastPostRequest(writer: SerializationWriter, debtForecastPostRequest: Partial<DebtForecastPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!debtForecastPostRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", debtForecastPostRequest.name);
    writer.writeAdditionalData(debtForecastPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ExchangeRatesGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExchangeRatesGetResponse(writer: SerializationWriter, exchangeRatesGetResponse: Partial<ExchangeRatesGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!exchangeRatesGetResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("currencyACode", exchangeRatesGetResponse.currencyACode);
    writer.writeStringValue("currencyBCode", exchangeRatesGetResponse.currencyBCode);
    writer.writeNumberValue("multiplier", exchangeRatesGetResponse.multiplier);
    writer.writeAdditionalData(exchangeRatesGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountGetAllResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountGetAllResponse(writer: SerializationWriter, investmentAccountGetAllResponse: Partial<InvestmentAccountGetAllResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountGetAllResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountGetAllResponse.balance);
    writer.writeStringValue("currencyId", investmentAccountGetAllResponse.currencyId);
    writer.writeCollectionOfObjectValues<InvestmentAccountGetAllResponseHoldingValue>("holdingsValues", investmentAccountGetAllResponse.holdingsValues, serializeInvestmentAccountGetAllResponseHoldingValue);
    writer.writeGuidValue("id", investmentAccountGetAllResponse.id);
    writer.writeDateValue("lastUpdated", investmentAccountGetAllResponse.lastUpdated);
    writer.writeStringValue("name", investmentAccountGetAllResponse.name);
    writer.writeStringValue("url", investmentAccountGetAllResponse.url);
    writer.writeAdditionalData(investmentAccountGetAllResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountGetAllResponseHoldingValue The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountGetAllResponseHoldingValue(writer: SerializationWriter, investmentAccountGetAllResponseHoldingValue: Partial<InvestmentAccountGetAllResponseHoldingValue> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountGetAllResponseHoldingValue || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountGetAllResponseHoldingValue.balance);
    writer.writeStringValue("currencyId", investmentAccountGetAllResponseHoldingValue.currencyId);
    writer.writeAdditionalData(investmentAccountGetAllResponseHoldingValue.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountGetResponse(writer: SerializationWriter, investmentAccountGetResponse: Partial<InvestmentAccountGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountGetResponse.balance);
    writer.writeStringValue("currencyId", investmentAccountGetResponse.currencyId);
    writer.writeGuidValue("id", investmentAccountGetResponse.id);
    writer.writeDateValue("lastUpdated", investmentAccountGetResponse.lastUpdated);
    writer.writeStringValue("name", investmentAccountGetResponse.name);
    writer.writeStringValue("url", investmentAccountGetResponse.url);
    writer.writeAdditionalData(investmentAccountGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountPatchRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountPatchRequest(writer: SerializationWriter, investmentAccountPatchRequest: Partial<InvestmentAccountPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountPatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountPatchRequest.balance);
    writer.writeStringValue("name", investmentAccountPatchRequest.name);
    writer.writeStringValue("url", investmentAccountPatchRequest.url);
    writer.writeAdditionalData(investmentAccountPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountPostRequest(writer: SerializationWriter, investmentAccountPostRequest: Partial<InvestmentAccountPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountPostRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountPostRequest.balance);
    writer.writeStringValue("currencyId", investmentAccountPostRequest.currencyId);
    writer.writeStringValue("name", investmentAccountPostRequest.name);
    writer.writeAdditionalData(investmentAccountPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountsOverviewGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountsOverviewGetResponse(writer: SerializationWriter, investmentAccountsOverviewGetResponse: Partial<InvestmentAccountsOverviewGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountsOverviewGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<InvestmentAccountsOverviewGetResponseBalance>("balances", investmentAccountsOverviewGetResponse.balances, serializeInvestmentAccountsOverviewGetResponseBalance);
    writer.writeAdditionalData(investmentAccountsOverviewGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountsOverviewGetResponseBalance The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountsOverviewGetResponseBalance(writer: SerializationWriter, investmentAccountsOverviewGetResponseBalance: Partial<InvestmentAccountsOverviewGetResponseBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountsOverviewGetResponseBalance || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<InvestmentAccountsOverviewGetResponseCurrencyBalance>("currencyBalances", investmentAccountsOverviewGetResponseBalance.currencyBalances, serializeInvestmentAccountsOverviewGetResponseCurrencyBalance);
    writer.writeStringValue("currencyId", investmentAccountsOverviewGetResponseBalance.currencyId);
    writer.writeAdditionalData(investmentAccountsOverviewGetResponseBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountsOverviewGetResponseCurrencyBalance The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountsOverviewGetResponseCurrencyBalance(writer: SerializationWriter, investmentAccountsOverviewGetResponseCurrencyBalance: Partial<InvestmentAccountsOverviewGetResponseCurrencyBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountsOverviewGetResponseCurrencyBalance || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", investmentAccountsOverviewGetResponseCurrencyBalance.balance);
    writer.writeStringValue("currencyId", investmentAccountsOverviewGetResponseCurrencyBalance.currencyId);
    writer.writeAdditionalData(investmentAccountsOverviewGetResponseCurrencyBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountTickerGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountTickerGetResponse(writer: SerializationWriter, investmentAccountTickerGetResponse: Partial<InvestmentAccountTickerGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountTickerGetResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("asAt", investmentAccountTickerGetResponse.asAt);
    writer.writeStringValue("currencyId", investmentAccountTickerGetResponse.currencyId);
    writer.writeNumberValue("currentPrice", investmentAccountTickerGetResponse.currentPrice);
    writer.writeStringValue("exchangeId", investmentAccountTickerGetResponse.exchangeId);
    writer.writeGuidValue("id", investmentAccountTickerGetResponse.id);
    writer.writeGuidValue("investmentAccountId", investmentAccountTickerGetResponse.investmentAccountId);
    writer.writeStringValue("name", investmentAccountTickerGetResponse.name);
    writer.writeStringValue("symbol", investmentAccountTickerGetResponse.symbol);
    writer.writeAdditionalData(investmentAccountTickerGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountTickerPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountTickerPostRequest(writer: SerializationWriter, investmentAccountTickerPostRequest: Partial<InvestmentAccountTickerPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountTickerPostRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("exchangeId", investmentAccountTickerPostRequest.exchangeId);
    writer.writeStringValue("symbol", investmentAccountTickerPostRequest.symbol);
    writer.writeAdditionalData(investmentAccountTickerPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountTransactionGetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountTransactionGetResponse(writer: SerializationWriter, investmentAccountTransactionGetResponse: Partial<InvestmentAccountTransactionGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountTransactionGetResponse || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", investmentAccountTransactionGetResponse.date);
    writer.writeGuidValue("id", investmentAccountTransactionGetResponse.id);
    writer.writeGuidValue("investmentAccountTickerId", investmentAccountTransactionGetResponse.investmentAccountTickerId);
    writer.writeNumberValue("price", investmentAccountTransactionGetResponse.price);
    writer.writeNumberValue("shares", investmentAccountTransactionGetResponse.shares);
    writer.writeAdditionalData(investmentAccountTransactionGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountTransactionPatchRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountTransactionPatchRequest(writer: SerializationWriter, investmentAccountTransactionPatchRequest: Partial<InvestmentAccountTransactionPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountTransactionPatchRequest || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", investmentAccountTransactionPatchRequest.date);
    writer.writeNumberValue("price", investmentAccountTransactionPatchRequest.price);
    writer.writeNumberValue("shares", investmentAccountTransactionPatchRequest.shares);
    writer.writeAdditionalData(investmentAccountTransactionPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InvestmentAccountTransactionPostRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvestmentAccountTransactionPostRequest(writer: SerializationWriter, investmentAccountTransactionPostRequest: Partial<InvestmentAccountTransactionPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!investmentAccountTransactionPostRequest || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", investmentAccountTransactionPostRequest.date);
    writer.writeNumberValue("price", investmentAccountTransactionPostRequest.price);
    writer.writeNumberValue("shares", investmentAccountTransactionPostRequest.shares);
    writer.writeAdditionalData(investmentAccountTransactionPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LoanGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLoanGetResponse(writer: SerializationWriter, loanGetResponse: Partial<LoanGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!loanGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", loanGetResponse.balance);
    writer.writeStringValue("currencyId", loanGetResponse.currencyId);
    writer.writeGuidValue("id", loanGetResponse.id);
    writer.writeNumberValue("interestRate", loanGetResponse.interestRate);
    writer.writeDateValue("lastUpdated", loanGetResponse.lastUpdated);
    writer.writeStringValue("name", loanGetResponse.name);
    writer.writeStringValue("notes", loanGetResponse.notes);
    writer.writeNumberValue("originalLoanAmount", loanGetResponse.originalLoanAmount);
    writer.writeGuidValue("repaymentScheduledTransactionId", loanGetResponse.repaymentScheduledTransactionId);
    writer.writeNumberValue("totalPayable", loanGetResponse.totalPayable);
    writer.writeStringValue("url", loanGetResponse.url);
    writer.writeAdditionalData(loanGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LoanPatchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLoanPatchRequest(writer: SerializationWriter, loanPatchRequest: Partial<LoanPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!loanPatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", loanPatchRequest.balance);
    writer.writeNumberValue("interestRate", loanPatchRequest.interestRate);
    writer.writeStringValue("name", loanPatchRequest.name);
    writer.writeStringValue("notes", loanPatchRequest.notes);
    writer.writeNumberValue("originalLoanAmount", loanPatchRequest.originalLoanAmount);
    writer.writeNumberValue("totalPayable", loanPatchRequest.totalPayable);
    writer.writeStringValue("url", loanPatchRequest.url);
    writer.writeAdditionalData(loanPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LoanPostRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLoanPostRequest(writer: SerializationWriter, loanPostRequest: Partial<LoanPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!loanPostRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", loanPostRequest.balance);
    writer.writeStringValue("currencyId", loanPostRequest.currencyId);
    writer.writeStringValue("name", loanPostRequest.name);
    writer.writeNumberValue("originalLoanAmount", loanPostRequest.originalLoanAmount);
    writer.writeNumberValue("totalPayable", loanPostRequest.totalPayable);
    writer.writeAdditionalData(loanPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LoansOverviewBalance The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLoansOverviewBalance(writer: SerializationWriter, loansOverviewBalance: Partial<LoansOverviewBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!loansOverviewBalance || isSerializingDerivedType) { return; }
    writer.writeStringValue("currencyId", loansOverviewBalance.currencyId);
    writer.writeNumberValue("totalBalance", loansOverviewBalance.totalBalance);
    writer.writeNumberValue("totalOriginalLoanAmount", loansOverviewBalance.totalOriginalLoanAmount);
    writer.writeNumberValue("totalPaid", loansOverviewBalance.totalPaid);
    writer.writeNumberValue("totalPayable", loansOverviewBalance.totalPayable);
    writer.writeAdditionalData(loansOverviewBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LoansOverviewGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLoansOverviewGetResponse(writer: SerializationWriter, loansOverviewGetResponse: Partial<LoansOverviewGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!loansOverviewGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<LoansOverviewBalance>("balances", loansOverviewGetResponse.balances, serializeLoansOverviewBalance);
    writer.writeAdditionalData(loansOverviewGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MortgageGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMortgageGetResponse(writer: SerializationWriter, mortgageGetResponse: Partial<MortgageGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mortgageGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", mortgageGetResponse.balance);
    writer.writeStringValue("currencyId", mortgageGetResponse.currencyId);
    writer.writeGuidValue("id", mortgageGetResponse.id);
    writer.writeNumberValue("interestRate", mortgageGetResponse.interestRate);
    writer.writeDateValue("lastUpdated", mortgageGetResponse.lastUpdated);
    writer.writeStringValue("name", mortgageGetResponse.name);
    writer.writeStringValue("notes", mortgageGetResponse.notes);
    writer.writeNumberValue("propertyValue", mortgageGetResponse.propertyValue);
    writer.writeDateOnlyValue("purchaseDate", mortgageGetResponse.purchaseDate);
    writer.writeNumberValue("purchasePrice", mortgageGetResponse.purchasePrice);
    writer.writeGuidValue("repaymentScheduledTransactionId", mortgageGetResponse.repaymentScheduledTransactionId);
    writer.writeStringValue("url", mortgageGetResponse.url);
    writer.writeAdditionalData(mortgageGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MortgagePatchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMortgagePatchRequest(writer: SerializationWriter, mortgagePatchRequest: Partial<MortgagePatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mortgagePatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", mortgagePatchRequest.balance);
    writer.writeNumberValue("interestRate", mortgagePatchRequest.interestRate);
    writer.writeStringValue("name", mortgagePatchRequest.name);
    writer.writeStringValue("notes", mortgagePatchRequest.notes);
    writer.writeNumberValue("propertyValue", mortgagePatchRequest.propertyValue);
    writer.writeDateOnlyValue("purchaseDate", mortgagePatchRequest.purchaseDate);
    writer.writeNumberValue("purchasePrice", mortgagePatchRequest.purchasePrice);
    writer.writeStringValue("url", mortgagePatchRequest.url);
    writer.writeAdditionalData(mortgagePatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MortgagePostRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMortgagePostRequest(writer: SerializationWriter, mortgagePostRequest: Partial<MortgagePostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mortgagePostRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", mortgagePostRequest.balance);
    writer.writeStringValue("currencyId", mortgagePostRequest.currencyId);
    writer.writeStringValue("name", mortgagePostRequest.name);
    writer.writeNumberValue("propertyValue", mortgagePostRequest.propertyValue);
    writer.writeDateOnlyValue("purchaseDate", mortgagePostRequest.purchaseDate);
    writer.writeNumberValue("purchasePrice", mortgagePostRequest.purchasePrice);
    writer.writeAdditionalData(mortgagePostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MortgagesOverviewBalance The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMortgagesOverviewBalance(writer: SerializationWriter, mortgagesOverviewBalance: Partial<MortgagesOverviewBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mortgagesOverviewBalance || isSerializingDerivedType) { return; }
    writer.writeStringValue("currencyId", mortgagesOverviewBalance.currencyId);
    writer.writeNumberValue("totalBalance", mortgagesOverviewBalance.totalBalance);
    writer.writeNumberValue("totalEquity", mortgagesOverviewBalance.totalEquity);
    writer.writeNumberValue("totalPropertyValue", mortgagesOverviewBalance.totalPropertyValue);
    writer.writeAdditionalData(mortgagesOverviewBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MortgagesOverviewGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMortgagesOverviewGetResponse(writer: SerializationWriter, mortgagesOverviewGetResponse: Partial<MortgagesOverviewGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mortgagesOverviewGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<MortgagesOverviewBalance>("balances", mortgagesOverviewGetResponse.balances, serializeMortgagesOverviewBalance);
    writer.writeAdditionalData(mortgagesOverviewGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProblemDetails The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProblemDetails(writer: SerializationWriter, problemDetails: Partial<ProblemDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!problemDetails || isSerializingDerivedType) { return; }
    writer.writeStringValue("detail", problemDetails.detail);
    writer.writeStringValue("instance", problemDetails.instance);
    writer.writeNumberValue("status", problemDetails.status);
    writer.writeStringValue("title", problemDetails.title);
    writer.writeStringValue("type", problemDetails.type);
    writer.writeAdditionalData(problemDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PromotionalBalanceGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionalBalanceGetResponse(writer: SerializationWriter, promotionalBalanceGetResponse: Partial<PromotionalBalanceGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!promotionalBalanceGetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", promotionalBalanceGetResponse.balance);
    writer.writeGuidValue("creditCardId", promotionalBalanceGetResponse.creditCardId);
    writer.writeDateOnlyValue("expiry", promotionalBalanceGetResponse.expiry);
    writer.writeGuidValue("id", promotionalBalanceGetResponse.id);
    writer.writeNumberValue("interestRate", promotionalBalanceGetResponse.interestRate);
    writer.writeDateValue("lastUpdated", promotionalBalanceGetResponse.lastUpdated);
    writer.writeDateOnlyValue("started", promotionalBalanceGetResponse.started);
    writer.writeAdditionalData(promotionalBalanceGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PromotionalBalancePatchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionalBalancePatchRequest(writer: SerializationWriter, promotionalBalancePatchRequest: Partial<PromotionalBalancePatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!promotionalBalancePatchRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", promotionalBalancePatchRequest.balance);
    writer.writeDateOnlyValue("expiry", promotionalBalancePatchRequest.expiry);
    writer.writeNumberValue("interestRate", promotionalBalancePatchRequest.interestRate);
    writer.writeDateOnlyValue("started", promotionalBalancePatchRequest.started);
    writer.writeAdditionalData(promotionalBalancePatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PromotionalBalancePostRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionalBalancePostRequest(writer: SerializationWriter, promotionalBalancePostRequest: Partial<PromotionalBalancePostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!promotionalBalancePostRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", promotionalBalancePostRequest.balance);
    writer.writeDateOnlyValue("expiry", promotionalBalancePostRequest.expiry);
    writer.writeNumberValue("interestRate", promotionalBalancePostRequest.interestRate);
    writer.writeDateOnlyValue("started", promotionalBalancePostRequest.started);
    writer.writeAdditionalData(promotionalBalancePostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ScheduledTransactionGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeScheduledTransactionGetResponse(writer: SerializationWriter, scheduledTransactionGetResponse: Partial<ScheduledTransactionGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!scheduledTransactionGetResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("accountId", scheduledTransactionGetResponse.accountId);
    writer.writeStringValue("accountName", scheduledTransactionGetResponse.accountName);
    writer.writeEnumValue<FrequencyType>("frequency", scheduledTransactionGetResponse.frequency);
    writer.writeNumberValue("frequencyMultiple", scheduledTransactionGetResponse.frequencyMultiple);
    writer.writeGuidValue("id", scheduledTransactionGetResponse.id);
    writer.writeBooleanValue("isCredit", scheduledTransactionGetResponse.isCredit);
    writer.writeBooleanValue("isVariable", scheduledTransactionGetResponse.isVariable);
    writer.writeDateOnlyValue("lastPaid", scheduledTransactionGetResponse.lastPaid);
    writer.writeDateOnlyValue("nextDue", scheduledTransactionGetResponse.nextDue);
    writer.writeStringValue("payee", scheduledTransactionGetResponse.payee);
    writer.writeNumberValue("value", scheduledTransactionGetResponse.value);
    writer.writeAdditionalData(scheduledTransactionGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ScheduledTransactionPatchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeScheduledTransactionPatchRequest(writer: SerializationWriter, scheduledTransactionPatchRequest: Partial<ScheduledTransactionPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!scheduledTransactionPatchRequest || isSerializingDerivedType) { return; }
    writer.writeEnumValue<FrequencyType>("frequency", scheduledTransactionPatchRequest.frequency);
    writer.writeNumberValue("frequencyMultiple", scheduledTransactionPatchRequest.frequencyMultiple);
    writer.writeBooleanValue("isVariable", scheduledTransactionPatchRequest.isVariable);
    writer.writeDateOnlyValue("nextDue", scheduledTransactionPatchRequest.nextDue);
    writer.writeStringValue("payee", scheduledTransactionPatchRequest.payee);
    writer.writeNumberValue("value", scheduledTransactionPatchRequest.value);
    writer.writeAdditionalData(scheduledTransactionPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ScheduledTransactionPostRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeScheduledTransactionPostRequest(writer: SerializationWriter, scheduledTransactionPostRequest: Partial<ScheduledTransactionPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!scheduledTransactionPostRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("accountId", scheduledTransactionPostRequest.accountId);
    writer.writeGuidValue("creditCardId", scheduledTransactionPostRequest.creditCardId);
    writer.writeEnumValue<FrequencyType>("frequency", scheduledTransactionPostRequest.frequency);
    writer.writeNumberValue("frequencyMultiple", scheduledTransactionPostRequest.frequencyMultiple);
    writer.writeBooleanValue("isCredit", scheduledTransactionPostRequest.isCredit);
    writer.writeBooleanValue("isVariable", scheduledTransactionPostRequest.isVariable);
    writer.writeGuidValue("loanId", scheduledTransactionPostRequest.loanId);
    writer.writeGuidValue("mortgageId", scheduledTransactionPostRequest.mortgageId);
    writer.writeDateOnlyValue("nextDue", scheduledTransactionPostRequest.nextDue);
    writer.writeStringValue("payee", scheduledTransactionPostRequest.payee);
    writer.writeNumberValue("value", scheduledTransactionPostRequest.value);
    writer.writeAdditionalData(scheduledTransactionPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SessionGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSessionGetResponse(writer: SerializationWriter, sessionGetResponse: Partial<SessionGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!sessionGetResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("defaultCurrencyId", sessionGetResponse.defaultCurrencyId);
    writer.writeStringValue("email", sessionGetResponse.email);
    writer.writeStringValue("emailHash", sessionGetResponse.emailHash);
    writer.writeStringValue("familyName", sessionGetResponse.familyName);
    writer.writeStringValue("givenName", sessionGetResponse.givenName);
    writer.writeGuidValue("id", sessionGetResponse.id);
    writer.writeAdditionalData(sessionGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitGetResponse(writer: SerializationWriter, splitGetResponse: Partial<SplitGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitGetResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("accountId", splitGetResponse.accountId);
    writer.writeStringValue("name", splitGetResponse.name);
    writer.writeGuidValue("splitId", splitGetResponse.splitId);
    writer.writeAdditionalData(splitGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitPatchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitPatchRequest(writer: SerializationWriter, splitPatchRequest: Partial<SplitPatchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitPatchRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", splitPatchRequest.name);
    writer.writeAdditionalData(splitPatchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitPeriodCalculationGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitPeriodCalculationGetResponse(writer: SerializationWriter, splitPeriodCalculationGetResponse: Partial<SplitPeriodCalculationGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitPeriodCalculationGetResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<SplitPeriodCalculationItem>("items", splitPeriodCalculationGetResponse.items, serializeSplitPeriodCalculationItem);
    writer.writeNumberValue("total", splitPeriodCalculationGetResponse.total);
    writer.writeAdditionalData(splitPeriodCalculationGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitPeriodCalculationItem The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitPeriodCalculationItem(writer: SerializationWriter, splitPeriodCalculationItem: Partial<SplitPeriodCalculationItem> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitPeriodCalculationItem || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", splitPeriodCalculationItem.amount);
    writer.writeGuidValue("scheduledTransactionId", splitPeriodCalculationItem.scheduledTransactionId);
    writer.writeAdditionalData(splitPeriodCalculationItem.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitPostRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitPostRequest(writer: SerializationWriter, splitPostRequest: Partial<SplitPostRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitPostRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", splitPostRequest.name);
    writer.writeAdditionalData(splitPostRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitScheduledTransactionGetRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitScheduledTransactionGetRequest(writer: SerializationWriter, splitScheduledTransactionGetRequest: Partial<SplitScheduledTransactionGetRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitScheduledTransactionGetRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("denominator", splitScheduledTransactionGetRequest.denominator);
    writer.writeNumberValue("numerator", splitScheduledTransactionGetRequest.numerator);
    writer.writeGuidValue("scheduledTransactionId", splitScheduledTransactionGetRequest.scheduledTransactionId);
    writer.writeGuidValue("splitId", splitScheduledTransactionGetRequest.splitId);
    writer.writeAdditionalData(splitScheduledTransactionGetRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SplitScheduledTransactionPutRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitScheduledTransactionPutRequest(writer: SerializationWriter, splitScheduledTransactionPutRequest: Partial<SplitScheduledTransactionPutRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!splitScheduledTransactionPutRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("denominator", splitScheduledTransactionPutRequest.denominator);
    writer.writeNumberValue("numerator", splitScheduledTransactionPutRequest.numerator);
    writer.writeGuidValue("scheduledTransactionId", splitScheduledTransactionPutRequest.scheduledTransactionId);
    writer.writeAdditionalData(splitScheduledTransactionPutRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StaticCurrency The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStaticCurrency(writer: SerializationWriter, staticCurrency: Partial<StaticCurrency> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!staticCurrency || isSerializingDerivedType) { return; }
    writer.writeStringValue("alternateCode", staticCurrency.alternateCode);
    writer.writeNumberValue("alternateMultiplier", staticCurrency.alternateMultiplier);
    writer.writeStringValue("code", staticCurrency.code);
    writer.writeNumberValue("decimalPlaces", staticCurrency.decimalPlaces);
    writer.writeStringValue("friendlyName", staticCurrency.friendlyName);
    writer.writeStringValue("symbol", staticCurrency.symbol);
    writer.writeAdditionalData(staticCurrency.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StatusGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStatusGetResponse(writer: SerializationWriter, statusGetResponse: Partial<StatusGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!statusGetResponse || isSerializingDerivedType) { return; }
    writer.writeObjectValue<StaticCurrency>("currency", statusGetResponse.currency, serializeStaticCurrency);
    writer.writeBooleanValue("hasAccounts", statusGetResponse.hasAccounts);
    writer.writeBooleanValue("hasCreditCards", statusGetResponse.hasCreditCards);
    writer.writeBooleanValue("hasInvestmentAccounts", statusGetResponse.hasInvestmentAccounts);
    writer.writeBooleanValue("hasLoans", statusGetResponse.hasLoans);
    writer.writeBooleanValue("hasMortgages", statusGetResponse.hasMortgages);
    writer.writeAdditionalData(statusGetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TransactionsGetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTransactionsGetResponse(writer: SerializationWriter, transactionsGetResponse: Partial<TransactionsGetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!transactionsGetResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("accountId", transactionsGetResponse.accountId);
    writer.writeDateOnlyValue("date", transactionsGetResponse.date);
    writer.writeBooleanValue("isCredit", transactionsGetResponse.isCredit);
    writer.writeBooleanValue("isPaid", transactionsGetResponse.isPaid);
    writer.writeBooleanValue("isVariable", transactionsGetResponse.isVariable);
    writer.writeStringValue("name", transactionsGetResponse.name);
    writer.writeGuidValue("scheduledTransactionId", transactionsGetResponse.scheduledTransactionId);
    writer.writeNumberValue("value", transactionsGetResponse.value);
    writer.writeAdditionalData(transactionsGetResponse.additionalData);
}
export interface SessionGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The defaultCurrencyId property
     */
    defaultCurrencyId?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The emailHash property
     */
    emailHash?: string | null;
    /**
     * The familyName property
     */
    familyName?: string | null;
    /**
     * The givenName property
     */
    givenName?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
}
export interface SplitGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The accountId property
     */
    accountId: Guid;
    /**
     * The name property
     */
    name: string;
    /**
     * The splitId property
     */
    splitId: Guid;
}
export interface SplitPatchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name: string;
}
export interface SplitPeriodCalculationGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The items property
     */
    items: SplitPeriodCalculationItem[];
    /**
     * The total property
     */
    total?: number | null;
}
export interface SplitPeriodCalculationItem extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount: number;
    /**
     * The scheduledTransactionId property
     */
    scheduledTransactionId: Guid;
}
export interface SplitPostRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name: string;
}
export interface SplitScheduledTransactionGetRequest extends AdditionalDataHolder, Parsable {
    /**
     * The denominator property
     */
    denominator: number;
    /**
     * The numerator property
     */
    numerator: number;
    /**
     * The scheduledTransactionId property
     */
    scheduledTransactionId: Guid;
    /**
     * The splitId property
     */
    splitId: Guid;
}
export interface SplitScheduledTransactionPutRequest extends AdditionalDataHolder, Parsable {
    /**
     * The denominator property
     */
    denominator: number;
    /**
     * The numerator property
     */
    numerator: number;
    /**
     * The scheduledTransactionId property
     */
    scheduledTransactionId: Guid;
}
export interface StaticCurrency extends AdditionalDataHolder, Parsable {
    /**
     * The alternateCode property
     */
    alternateCode?: string | null;
    /**
     * The alternateMultiplier property
     */
    alternateMultiplier?: number | null;
    /**
     * The code property
     */
    code: string;
    /**
     * The decimalPlaces property
     */
    decimalPlaces?: number | null;
    /**
     * The friendlyName property
     */
    friendlyName: string;
    /**
     * The symbol property
     */
    symbol?: string | null;
}
export interface StatusGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The currency property
     */
    currency: StaticCurrency;
    /**
     * The hasAccounts property
     */
    hasAccounts: boolean;
    /**
     * The hasCreditCards property
     */
    hasCreditCards: boolean;
    /**
     * The hasInvestmentAccounts property
     */
    hasInvestmentAccounts: boolean;
    /**
     * The hasLoans property
     */
    hasLoans: boolean;
    /**
     * The hasMortgages property
     */
    hasMortgages: boolean;
}
export interface TransactionsGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The accountId property
     */
    accountId: Guid;
    /**
     * The date property
     */
    date: DateOnly;
    /**
     * The isCredit property
     */
    isCredit?: boolean | null;
    /**
     * The isPaid property
     */
    isPaid?: boolean | null;
    /**
     * The isVariable property
     */
    isVariable?: boolean | null;
    /**
     * The name property
     */
    name: string;
    /**
     * The scheduledTransactionId property
     */
    scheduledTransactionId?: Guid | null;
    /**
     * The value property
     */
    value: number;
}
export const CreditCardPaymentBehaviourObject = {
    MainBalanceOnly: "MainBalanceOnly",
    UpdatePromotionalBalances: "UpdatePromotionalBalances",
} as const;
export const FrequencyTypeObject = {
    OneOff: "OneOff",
    Weekly: "Weekly",
    Monthly: "Monthly",
    OpenapiJsonNullSentinelValue2BF936000FE44250987AE5DDB203E464: "openapi-json-null-sentinel-value-2BF93600-0FE4-4250-987A-E5DDB203E464",
} as const;
/* tslint:enable */
/* eslint-enable */




